var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDollarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.85037 10.4094C6.85037 11.1802 7.45097 11.8108 8.1817 11.8108H9.68321C10.3238 11.8108 10.8444 11.2603 10.8444 10.5896C10.8444 9.85887 10.524 9.59861 10.0536 9.42844L7.65117 8.5876C7.17069 8.41743 6.85037 8.15717 6.85037 7.42644C6.85037 6.75577 7.37089 6.20522 8.01153 6.20522H9.51303C10.2538 6.21523 10.8544 6.83585 10.8544 7.60662M8.85237 11.8609V12.6016M8.85237 5.41443V6.19521",
    stroke: "#807CCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8354 18.8979C12.7363 20.1692 14.2077 21 15.8894 21C18.6221 21 20.8444 18.7778 20.8444 16.045C20.8444 14.3834 20.0235 12.9119 18.7723 12.011M8.84236 16.996C10.9636 16.996 12.9979 16.1534 14.4978 14.6534C15.9977 13.1535 16.8404 11.1192 16.8404 8.998C16.8404 6.8768 15.9977 4.84247 14.4978 3.34256C12.9979 1.84264 10.9636 1 8.84236 1C6.72116 1 4.68684 1.84264 3.18692 3.34256C1.687 4.84247 0.84436 6.8768 0.84436 8.998C0.84436 11.1192 1.687 13.1535 3.18692 14.6534C4.68684 16.1534 6.72116 16.996 8.84236 16.996Z",
    stroke: "#807CCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIcon);
export default __webpack_public_path__ + "static/media/dollar-icon.6cb796683bc25efd3f8a75d085c2918b.svg";
export { ForwardRef as ReactComponent };